import React from 'react';
import Logo from '../../assets/logo-vodovod-rijeka.png'; // Adjust path based on your project structure
import './Terms.css';

const Terms = () => {
  const handleLinkPress = (url) => {
    window.open(url, '_blank'); // Opens the URL in a new tab
  };

  return (
    <div className="container">
      <div className="header-container">
        <img src={Logo} alt="KD VODOVOD  I  KANALIZACIJA  d.o.o." className="logo" />
        <h1 className="title">Uvjeti korištenja usluge Moj ViK</h1>
      </div>

      <div className="section">
        <h2 className="section-title">1. Osnovne informacije</h2>
        <p className="subsection">
          Moj  ViK  je  usluga  koja  je  namijenjena  evidentiranim  korisnicima  vodnih  usluga  čiji  je  isporučitelj  KD VODOVOD  I  KANALIZACIJA  d.o.o.  putem  korisničkog  portala,  za  što  je  potrebno  prethodno  izvršiti obaveznu registraciju.
        </p>
        <p className="subsection">
          Usluga omogućuje registriranom korisniku zaštićeni pristup do informacija i podataka vezanih uz njegovu potrošnju,  izdane  mu  račune  te  mu  omogućuje  pregled  njegovih  uplata,  dojavu  stanje  vodomjera i aktiviranje usluge primanja računa i obavijesti o uvećanoj potrošnji na adresu elektronske pošte. 
        </p>
        <p className="subsection">
          Usluga je  dostupna  pravnim i  fizičkim  osobama koji  su evidentirani kao korisnici vodnih usluga javnog isporučitelja KD VODOVOD I KANALIIZACIJA d.o.o. 
        </p>
        <p className="subsection">
          Usluga je u vlasništvu isporučitelja vodnih usluga KD VODOVOD I KANALIZACIJA d.o.o. 
        </p>
        <p className="subsection">
         Usluga je, kao i sve njezine nadogradnje te ažuriranja, besplatna za registrirane korisnike. Nadogradnje  i  ažuriranja  su  u  funkciji  proširenja  usluge  novim  funkcionalnostima  te  ispravljanjima mogućih grešaka
        </p>
        <p className="subsection">
          Usluga  se korisniku aktivira po uspješno izvršenoj  registraciji  te prihvaćanju uvjeta korištenja i izjave o zaštiti osobnih podataka. Korištenje je omogućeno putem jedinstvenog korisničkog računa, koje se sastoji od korisničkog imena i lozinke. Prihvaćanjem uvjeta korištenja korisnik potvrđuje da je korisnički račun istoznačan  vlastoručnom  potpisu  korisnika  čiji  se  OIB  i  šifra  korisnika  unose  prilikom  registracije  i aktivacije, a sukladno tome se omogućuju i primjenjuju promjene statusa određenih servisa unutar usluge Moj ViK.
        </p>
        <p className="subsection">
          Korisnik je dužan čuvati svoje korisničko ime i lozinku  te je ne dijeli s drugim osobama, sve sa svrhom 
zaštite od neovlaštenog korištenja usluge Moj ViK ‐ dolaska do osjetljivih podataka ili neželjena mijenjana 
statusa omogućenih unutar usluge. 
        </p>
        <p className="subsection">
          Isporučitelj  KD  VODOVOD  I  KANALIZACIJA  d.o.o.  ne  preuzima  odgovornost  u  slučaju  neovlaštenog 
korištenja  korisničkog  računa  (korisničkog  imena  i  lozinke)  i  bilo  kakvu  štetu  nastalu  eventualnim 
neovlaštenim korištenjem usluge Moj ViK. 
        </p>

        <p className="subsection">
          Uslugu Moj  ViK moguće je  deaktivirati,  kao  i  otkazati aktivirane  servise  unutar  usluge Moj  ViK  (poput 
primanja  računa  i  obavijesti  o  uvećanoj  potrošnji  na  korisnikovu  adresu  elektroničke  pošte),  pisanim 
putem: 
‐ elektroničkom poštom na adresu registar@kdvik‐rijeka.hr) 
‐ redovnom poštom naslovljeno KD VODOVOD I KANALIZACIJA d.o.o. ‐  Dolac 14, 51000 Rijeka.
        </p>
      </div>

      <div className="section">
        <h2 className="section-title">2. Korištenje Usluge</h2>
        <p className="subsection">
          Korištenje usluge započinje registracijom usluge Moj ViK. 
        </p>
        <p className="subsection">
          Isporučitelj povremeno nadograđuje i ažurira uslugu Moj ViK.
        </p>
        <p className="subsection">
          Usluga Moj ViK omogućena je: 
‐ putem korisničkog portala – optimalno na internetskim preglednicima
‐ Google Chrome 57 i novija verzija 
‐ Microsoft Edge 40 i novija verzija 
‐ Mozilla Firefox 51 i novija verzija 
‐ Internet Explorer 11 i novija verzija  
‐ Opera 42 i novija verzija 
‐ Apple Safari 13 i novija verzija.
        </p>
        <p className="subsection">
          U drugim verzijama isporučitelj ne odgovara na ispravnost  funkcioniranja usluge, odnosno korisničkog 
portala. 
        </p>
        <p className="subsection">
         Kako bi korištenje usluge Moj ViK bilo što sigurnije i ispravnije, svaka uočena greška slobodno se može 
prijaviti ili putem korisničkog portala Moj Vik (u rubrici Pomoć) ili na kdvik‐rijeka@kdvik‐rijeka.hr  
        </p>
        <p className="subsection">
          Korisnik neće smatrati isporučitelja vodnih usluga KD VODOVOD I KANALIZACIJA d.o.o. odgovornim za bilo 
kakve greške u korištenju usluge Moj ViK; eventualno kašnjenje u prijenosu i prikazu podataka, odnosno 
ukoliko oni neće biti dostupni u nekom trenutku. 
        </p>
        <p className="subsection">
          Aktivacijom usluge primanja računa i obavijesti o uvećanoj potrošnji na adresu svoje elektroničke pošte, 
korisnik  preuzima  obvezu mogućnosti  isporuke  mu  tih  dokumenata  u  svakom  trenutku. U  protivnom, 
smatra se da su dokumenti isporučeni. Dostupni su također po prijavi korisnika na korisničkom portalu.
        </p>
        <p className="subsection">
          Sadržaj koji je objavljen na korisničkom portalu Moj ViK  ne smije se reproducirati, distribuirati ili na bilo 
koji način upotrebljavati bez izričitog pristanka KD VODOVOD I KANALIZACIJA d.o.o. ili na bilo koji način 
koji može uzrokovati štetu KD VODOVOD I KANALIZACIJA d.o.o. ili bilo kojoj trećoj strani.  
Sadržaj  koji  je  objavljen  na  korisničkom  portalu Moj  ViK  može  se  upotrebljavati  samo  za  individualne 
potrebe korisnika i na njihovu vlastitu odgovornost uz poštovanje svih prava trećih osoba te u skladu s 
ovim Uvjetima. 
        </p>
      </div>

      <div className="section">
        <h2 className="section-title">3. Odricanje od odgovornosti</h2>
        <p className="subsection">
          Isporučitelj  KD VODOVOD I  KANALIZACIJA d.o.o.  ne preuzima nikakvu odgovornost  za bilo kakvu  štetu 
nastalu korištenjem usluge Moj ViK. To podrazumijeva i neprihvaćanje bilo kakve odgovornosti za izravan 
kao i neizravan gubitak, uključujući, ali ne ograničavajući se samo na gubitak zbog slučajne ili posljedične 
štete. 
        </p>
      </div>

      <div className="section">
        <h2 className="section-title">4. Pravo izmjene</h2>
        <p className="subsection">
          Isporučitelj KD VODOVOD I KANALIZACIJA d.o.o. zadržava pravo na ispravke i dopune Uvjeta korištenja.  
        </p>
        <p className="subsection">
         Važeća  verzija  Uvjeta  korištenja  korisnicima  je  dostupna  na  internetskim  stranicama  KD  VODOVOD  I 
KANALIZACIJA d.o.o. (www.kdvik‐rijeka.hr) . 
        </p>
        <p className="subsection">
         U slučaju promjene ovih Uvjeta, Korisnici neće prihvaćati izmijenjene Uvjete, već će se na iste novi Uvjeti 
primjenjivati od dana njihove objave 
        </p>
      </div>

      <div className="section">
        <h2 className="section-title">5. Zašita osobnih podataka (GDPR) </h2>
        <p className="subsection">
          Isporučitelj  KD  VODOVOD I  KANALIZACIJA  d.o.o.  posluje  usklađeno  s  obvezama  koje  proizlaze  iz Opće 
uredbe o zaštiti osobnih podataka te se adekvatnim organizacijskim i tehničkim mjerama osigurava zaštita 
vaših osobnih podataka.    
        </p>
      </div>
Ovi Uvjeti korištenja primjenjuju se od prosinca 2020. 
    </div>
  );
};

export default Terms;